export const OUR_OFFERS = [{
  type: 'Групповое занятие',
  duration: '60 минут',
  studentsNumber: 'до 4-6',
  price: 3500
}, {
  type: 'Групповое занятие',
  duration: '90 минут',
  studentsNumber: 'до 8',
  price: 4500
}, {
  type: 'Индивидуальное занятие',
  duration: '60 минут',
  studentsNumber: '1',
  price: 2200
}];